import { useStoreSelector } from '@/store';
import { Spin } from 'antd';
import nProgress from 'nprogress';
import { lazy, Suspense, useEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { PRIVATE_ROUTES, PUBLIC_ROUTES } from './paths';
import { privateRoutes } from './privateRoutes';
import { publicRoutes } from './publicRoutes';

const AuthLayout = lazy(() => import('@/components/layouts/AuthLayout'));
const DashboardLayout = lazy(() => import('@/components/layouts/DashboardLayout'));
const NotFound = lazy(() => import('@/pages/NotFound'));
const SearchInvoice = lazy(() => import('@/pages/SearchInvoice'));
const DetailInvoice = lazy(() => import('@/pages/DetailInvoice'));

export const BaseRoutes = () => {
	const { routeChange } = useStoreSelector((state) => state.app);

	useEffect(() => {
		if (routeChange === 'start') {
			nProgress.start();
		} else {
			nProgress.done();
		}
	}, [routeChange]);

	return (
		<BrowserRouter>
			<Routes>
				<Route
					path='search-invoice'
					element={
						<Suspense fallback={<Spin size='large' className='spin-loading-page' />}>
							<SearchInvoice />
						</Suspense>
					}
				/>
				<Route
					path='search-invoice/:invoiceId'
					element={
						<Suspense fallback={<Spin size='large' className='spin-loading-page' />}>
							<DetailInvoice />
						</Suspense>
					}
				/>
				<Route path='/auth' element={<AuthLayout />}>
					{publicRoutes?.map(({ path, Component }, i) => (
						<Route
							key={i}
							path={path}
							index={path === PUBLIC_ROUTES.AUTH}
							element={
								<Suspense fallback={<Spin size='large' className='spin-loading-page' />}>
									<Component />
								</Suspense>
							}
						/>
					))}
				</Route>
				<Route path='/panel' element={<DashboardLayout />}>
					{privateRoutes?.map(({ path, Component }, i) => (
						<Route
							key={i}
							path={path}
							index={path === PRIVATE_ROUTES.PANEL}
							element={
								<Suspense fallback={<Spin size='large' className='spin-loading-page' />}>
									<Component />
								</Suspense>
							}
						/>
					))}
				</Route>
				<Route
					path='/'
					element={<Navigate to={`/${PRIVATE_ROUTES.PANEL}/${PRIVATE_ROUTES.DASHBOARD}`} />}
				/>
				{/* Add this line to handle redirection */}
				<Route path='*' element={<NotFound />} />
			</Routes>
		</BrowserRouter>
	);
};
